var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1663 19.9997C36.1663 28.9277 28.9277 36.1663 19.9997 36.1663C11.0717 36.1663 3.83301 28.9277 3.83301 19.9997C3.83301 11.0717 11.0717 3.83301 19.9997 3.83301C28.9277 3.83301 36.1663 11.0717 36.1663 19.9997Z",
    stroke: "#D4D1D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 18.3337H21.667V27.5003H18.3337V18.3337ZM22.0837 13.7503C22.0837 14.8995 21.1495 15.8337 20.0003 15.8337C18.8512 15.8337 17.917 14.8995 17.917 13.7503C17.917 12.6012 18.8512 11.667 20.0003 11.667C21.1495 11.667 22.0837 12.6012 22.0837 13.7503Z",
    fill: "#D4D1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.78b1b2fa0a9c53ffbc4651b121eac04e.svg";
export { ForwardRef as ReactComponent };